import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TermsPage = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/site-settings`);
        setContent(response.data?.terms_of_service);
      } catch (error) {
        console.error("Error fetching terms:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  const defaultContent = {
    title: "Terms of Service",
    last_updated: new Date().toISOString().split('T')[0],
    content: `<h2>Acceptance of Terms</h2>
<p>By accessing and using Mix & Mingle's services, you accept and agree to be bound by these Terms of Service.</p>

<h2>Services</h2>
<p>Mix & Mingle provides mocktail catering services for events including weddings, corporate events, and private parties.</p>

<h2>Booking and Payment</h2>
<ul>
<li>A deposit is required to secure your booking</li>
<li>Full payment is due before or on the day of your event</li>
<li>Cancellations must be made at least 14 days in advance for a full refund</li>
</ul>

<h2>Event Policies</h2>
<p>We require access to the venue at least 2 hours before the event start time for setup. The client is responsible for providing adequate space and facilities.</p>

<h2>Liability</h2>
<p>Mix & Mingle is not liable for damages arising from circumstances beyond our control. Our liability is limited to the amount paid for services.</p>

<h2>Changes to Terms</h2>
<p>We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of updated terms.</p>

<h2>Contact</h2>
<p>For questions about these Terms of Service, please contact us.</p>`
  };

  const terms = content || defaultContent;

  return (
    <main className="pt-20 min-h-screen bg-[#050505]" data-testid="terms-page">
      <div className="container-luxury py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto"
        >
          <h1 className="text-4xl font-['Playfair_Display'] font-bold text-[#F5F5F0] mb-4">
            {terms.title}
          </h1>
          <p className="text-[#A1A1AA] mb-8">
            Last updated: {terms.last_updated}
          </p>
          <div className="gold-divider mb-8" />
          
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="spinner" />
            </div>
          ) : (
            <div 
              className="prose prose-invert max-w-none policy-content"
              dangerouslySetInnerHTML={{ __html: terms.content }}
            />
          )}
        </motion.div>
      </div>
      
      <style>{`
        .policy-content {
          color: #A1A1AA;
          line-height: 1.8;
        }
        .policy-content h2 {
          font-size: 1.5em;
          font-weight: bold;
          color: #F5F5F0;
          font-family: 'Playfair Display', serif;
          margin-top: 2em;
          margin-bottom: 0.5em;
        }
        .policy-content h3 {
          font-size: 1.25em;
          font-weight: bold;
          color: #D4AF37;
          margin-top: 1.5em;
          margin-bottom: 0.5em;
        }
        .policy-content p {
          margin-bottom: 1em;
        }
        .policy-content ul, .policy-content ol {
          padding-left: 1.5em;
          margin-bottom: 1em;
        }
        .policy-content li {
          margin-bottom: 0.5em;
        }
        .policy-content a {
          color: #D4AF37;
          text-decoration: underline;
        }
      `}</style>
    </main>
  );
};

export default TermsPage;
